import React, { ReactNode, createContext, useContext, useState } from 'react'

import { createConfig } from 'wagmi'

import { AppKit } from '@reown/appkit'
import { W3mFrameProvider } from '@reown/appkit-wallet'
import { createAppKitWalletButton } from '@reown/appkit-wallet-button/react'

type AppKitContextType = {
  wagmiConfig: ReturnType<typeof createConfig>
  appkit: AppKit
  provider: W3mFrameProvider | undefined
  setProvider: (provider: W3mFrameProvider | undefined) => void
  appKitWalletButton: ReturnType<typeof createAppKitWalletButton>
}

const AppKitContext = createContext<AppKitContextType | undefined>(undefined)

type AppKitProviderProps = {
  appkit: AppKit
  wagmiConfig: ReturnType<typeof createConfig>
  appKitWalletButton: ReturnType<typeof createAppKitWalletButton>
  children: ReactNode
}

export const AppKitProvider: React.FC<AppKitProviderProps> = ({
  children,
  appkit,
  wagmiConfig,
  appKitWalletButton
}) => {
  const [provider, setProvider] = useState<W3mFrameProvider>()

  return (
    <AppKitContext.Provider
      value={{ appkit, wagmiConfig, provider, setProvider, appKitWalletButton }}
    >
      {children}
    </AppKitContext.Provider>
  )
}

export const useAppKitContext = (): AppKitContextType => {
  const context = useContext(AppKitContext)
  if (!context) {
    throw new Error('useAppKit must be used within an AppKitProvider')
  }
  return context
}

export default AppKitContext
